import { PerformanceMarks } from '@fiverr-private/obs';

if (typeof window.PerformanceObserver === 'function') {
    window.addEventListener(
        'load',
        () => {
            performance.mark(PerformanceMarks.WINDOW_LOAD);
            const script = document.createElement('script');
            script.src = 'https://npm-assets.fiverrcdn.com/assets/@fiverr-private/rum/index.latest.min.js';
            script.setAttribute('crossorigin', 'anonymous');
            script.setAttribute('defer', 'defer');
            document.body.appendChild(script);
        },
        { once: true }
    );
}
